import { useVariantValue } from '@trashlab/sitesapp/src/organizations/denversiteworks/lib/utils/get-variant-value';
import {
  getTextColorClass,
  isLightColor,
} from '@trashlab/sitesapp/src/organizations/denversiteworks/lib/utils/get-text-color';

/**
 * Hook to get the appropriate text color class based on the background color variant
 * @returns Object with text color class and whether the background is light
 */
export function useThemeTextColor() {
  const backgroundColor = useVariantValue('THEME_BACKGROUND_COLOR', '#001B5E');
  const isLight = isLightColor(backgroundColor);
  const textColorClass = getTextColorClass(backgroundColor);

  return {
    textColorClass,
    isLightBackground: isLight,
    backgroundColor,
  };
}
